export enum HouseAndLandNationalPermission {
    None = 0x00,
    CanView = 0x01 << 0,
    CanEdit = 0x01 << 1,
}
